import React from 'react';
import { Stats } from '../types';
import './Header.css';

interface HeaderProps {
  stats: Stats | null;
  isLoading: boolean;
}

const Header: React.FC<HeaderProps> = ({ stats, isLoading }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fi-FI', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-section">
          <div className="logo">
            <span className="logo-text">Kärpät</span>
          </div>
          <h1 className="title">Tähtipelaajat 2025-2026</h1>
          <p className="subtitle">
            <a 
              href="https://keskustelu.jatkoaika.com/threads/k%C3%A4rppien-t%C3%A4htipelaajat-kaudella-2025%E2%80%932026.82329/"
              target="_blank"
              rel="noopener noreferrer"
              className="subtitle-link"
            >
              Keskustelu.jatkoaika.com -äänestystulokset
            </a>
          </p>
        </div>
        
        <div className="stats-section">
          {isLoading ? (
            <div className="loading-stats">
              <div className="loading-spinner"></div>
              <span>Ladataan...</span>
            </div>
          ) : stats ? (
            <div className="stats-grid">
              <div className="stat-item">
                <span className="stat-label">Pelaajia</span>
                <span className="stat-value">{stats.totalPlayers}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Kierros</span>
                <span className="stat-value">{stats.currentRound}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Päivitetty</span>
                <span className="stat-value">{formatDate(stats.lastUpdated)}</span>
              </div>
            </div>
          ) : (
            <div className="no-stats">
              <span>Ei tilastoja saatavilla</span>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
